import { TFunction } from 'i18next';
import { useState } from 'react';
import { TLayout } from '../../layout';

const THUMBNAILS = [
  'https://assets.mobitech.id/images/thumbnail-tutorial-order-management.png',
  'https://assets.mobitech.id/images/thumbnail-tutorial-smart-planning.png',
];

const useTutorialVideo = (t: TFunction, config: TLayout['config']) => {
  const videosArr = [
    {
      id: 'order-management',
      url: config?.urlTutorialOrderManagement,
      embedUrl: config?.urlTutorialEmbedOrderManagement,
      thumbnail: THUMBNAILS[0],
      card: {
        title: t('order_management.card_title'),
        description: t('order_management.card_description'),
      },
      video: {
        title: t('order_management.title'),
        description: t('order_management.description'),
      },
    },
    {
      id: 'smart-planning',
      url: config?.urlTutorialSmartPlanning,
      embedUrl: config?.urlTutorialEmbedSmartPlanning,
      thumbnail: THUMBNAILS[1],
      card: {
        title: t('smart_planning.card_title'),
        description: t('smart_planning.card_description'),
      },
      video: {
        title: t('smart_planning.title'),
        description: t('smart_planning.description'),
      },
    },
  ];

  const [activeTutorial, setActiveTutorial] = useState(videosArr[0]);

  const onClickCard = (id: string) => {
    const video = videosArr.find((video) => video.id === id);
    if (video) {
      setActiveTutorial(video);
    }
  };

  return {
    activeTutorial,
    onClickCard,
    videosArr,
  };
};

export default useTutorialVideo;
